import API from "./lib/api";
import { departmentUrl, restaurantStaffUrl, staffUrl, verifyPinUrl } from "./lib/url";

export const getAllDepartment = async () => {
  try {
    const { data } = await API.get(`${departmentUrl}`);

    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getAllStaffRole = async (id) => {
  try {
    const { data } = await API.get(`${departmentUrl}/${id}/roles`);

    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getStaffAllResponsibility = async (id) => {
  try {
    const { data } = await API.get(
      `${departmentUrl}/${id}/staff-responsibility`
    );

    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getAllStaff = async () => {
  try {
    const { data } = await API.get(`${staffUrl}`);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const searchStaffApi = async (restaurantId, query) => {
    try {
        const { data } = await API.get( 
            `restaurants/${restaurantId}/staff/search?first_name=${query}`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const getSingleStaff = async (id) => {
  try {
    const { data } = await API.get(`${staffUrl}/${id}`);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const AddStaffApi = async (staffData) => {
  try {
    const { data } = await API.post(`${staffUrl}`, staffData);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const editStaffApi = async (id, staffData) => {
  console.log(staffData);
  try {
    const { data } = await API.put(`${staffUrl}/${id}`, staffData);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteStaffApi = async (id) => {
  try {
    const { data } = await API.delete(`${staffUrl}/${id}`);

    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const getRestaurantStaff = async (restaurant_system_id, device_id) => {
  try {
    const { data } = await API.get(`${restaurantStaffUrl}/${restaurant_system_id}?token_web=${device_id}`);
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const clockInApi = async (staffData) => {
  try {
    const { data } = await API.post(`user-check_in`, staffData);
    return data;
  } catch (error) {
    return error?.response?.data || { status: "failure", message: error?.message || "Failed to check in" };
  }
};

export const clockOutApi = async (staffData) => {
  try {
    const { data } = await API.post(`user-check_out`, staffData);
    return data;
  } catch (error) {
    return error?.response?.data || { status: "failure", message: error?.message || "Failed to check out" };
  }
};

export const breakInApi = async (staffData) => {
  try {
    const { data } = await API.post(`break-in`, staffData);
    return data;
  } catch (error) {
    return error?.response?.data || { status: "failure", message: error?.message || "Failed to break in" };
  }
};

export const breakOutApi = async (staffData) => {
  try {
    const { data } = await API.post(`break-out`, staffData);
    return data;
  } catch (error) {
    return error?.response?.data || { status: "failure", message: error?.message || "Failed to break out" };
  }
};

export const staffLoginApi = async (staffData) => {
  try {
    const { data } = await API.post(`user-login`, staffData);
    return data;
  } catch (error) {
    return error?.response?.data || { status: "failure", message: error?.message || "Failed to login" };
  }
};

export const verifyPinApi = async (staffData) => {
  try {
    const { data } = await API.post(verifyPinUrl || `verify-pin`, staffData);

    return data;
  } catch (error) {
    return (
      error?.response?.data || {
        status: "failure",
        message: error?.message || "Failed to verify PIN",
      }
    );
  }
};

export const staffLogOutApi = async (staffData) => {
  try {
    const { data } = await API.post(`user-logout`, staffData);

    return data;
  } catch (error) {
    return error.response.data;
  }
};



export const addNewDevice = async (deviceData) => {
  try {
    const { data } = await API.post(`/admin/devices`, deviceData);

    return data;
  } catch (error) {
    return error.response.data;
  }
};